/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./check-auth.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./check-auth.component";
import * as i3 from "@angular/router";
import * as i4 from "../../app/shared/common/IDSVRAuthProviders/auth.service";
var styles_CheckAuthComponent = [i0.styles];
var RenderType_CheckAuthComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_CheckAuthComponent, data: {} });
export { RenderType_CheckAuthComponent as RenderType_CheckAuthComponent };
export function View_CheckAuthComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_CheckAuthComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-check-auth", [], null, null, null, View_CheckAuthComponent_0, RenderType_CheckAuthComponent)), i1.ɵdid(1, 114688, null, 0, i2.CheckAuthComponent, [i3.Router, i3.ActivatedRoute, i4.AuthService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CheckAuthComponentNgFactory = i1.ɵccf("app-check-auth", i2.CheckAuthComponent, View_CheckAuthComponent_Host_0, {}, {}, []);
export { CheckAuthComponentNgFactory as CheckAuthComponentNgFactory };
